import { isMobileView } from '../utilities/index.js';

class CheckBoxControl {
  constructor(wrap) {
    if (!wrap) return;
    this.wrap = wrap;
    this.groups = [];

    const fieldsets = this.wrap.querySelectorAll('fieldset');
    fieldsets.forEach(fieldset => {
      const checkboxes = fieldset.querySelectorAll('.checkboxLabel input[type="checkbox"]');
      const allCheckbox = fieldset.querySelector('.checkboxLabel--allCheck input[type="checkbox"]');
      const otherCheckboxes = Array.from(checkboxes).filter(cb => cb !== allCheckbox);

      if (allCheckbox && otherCheckboxes.length > 0) {
        this.groups.push({ allCheckbox, otherCheckboxes });
      }
    });

    this.bindEvents();
  }

  bindEvents() {
    this.groups.forEach(({ allCheckbox, otherCheckboxes }) => {
      allCheckbox.addEventListener('change', () => {
        if (allCheckbox.checked) {
          otherCheckboxes.forEach(cb => cb.checked = false);
        }
      });

      otherCheckboxes.forEach(cb => {
        cb.addEventListener('change', () => {
          if (cb.checked) {
            allCheckbox.checked = false;
          } else {
            const anyChecked = otherCheckboxes.some(other => other.checked);
            if (!anyChecked) {
              allCheckbox.checked = true;
            }
          }
        });
      });
    });
  }
}

class MobileAccordion {
  constructor(wrap) {
    if (!wrap || !isMobileView()) return;

    this.wrap = wrap;
    this.trigger = this.wrap.querySelector('.page-serviceCase__spFormAccordion__trigger');

    if (!this.trigger) return;

    this.init();
    this.bindEvents();
  }

  init() {
    const isInitOpen = this.wrap.classList.contains('is-acOpenInit');
    if (isInitOpen) {
      this.wrap.classList.add('is-acOpen');
    } else {
      this.wrap.classList.remove('is-acOpen');
    }
  }

  bindEvents() {
    this.trigger.addEventListener('click', (e) => {
      e.stopPropagation();
      this.wrap.classList.toggle('is-acOpen');
    });
  }
}

class ScrollToResultHead {
  constructor(resultHead, headerSelector) {
    this.resultHead = resultHead;
    this.header = document.querySelector(headerSelector);
  }

  runIfNeeded(paramKeys = []) {
    if (!this.resultHead) return;

    const params = new URLSearchParams(window.location.search);
    const hasRelevantParams = paramKeys.some(key => params.has(key));

    if (hasRelevantParams) {
      const headerHeight = this.header ? this.header.offsetHeight : 0;
      const offset = this.resultHead.getBoundingClientRect().top + window.scrollY - headerHeight * 2;

      window.scrollTo({
        top: offset,
        behavior: 'smooth'
      });
    }
  }
}

(function () {
  'use strict';

  const formWrap = document.querySelector('.js-case-search-form');
  if (formWrap) {
    new CheckBoxControl(formWrap);
  }

  const accordionWrap = document.querySelector('.js-case-search-accordion');
  if (accordionWrap) {
    new MobileAccordion(accordionWrap);
  }

  const resultHead = document.querySelector('.page-serviceCase__resultHead');
  if(resultHead) {
    new ScrollToResultHead(resultHead, '.l-header')
    .runIfNeeded(['sector[]', 'field[]']);
  }
})();
